import React, { useState } from "react";
import "./styles/CardView.css";
import { toggleStudy } from "../../endpoints/FlashCards/functions";
import { IconButton, Popover } from "@mui/material";
import {
  CloseRounded,
  LocalLibraryRounded,
  MoreVertRounded,
  WorkspacePremiumRounded,
} from "@mui/icons-material";

const SubContent = ({ label, content }) => {
  return (
    <div>
      <i>
        <b>{label}</b>
      </i>
      <p>{content}</p>
    </div>
  );
};

const Cards = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  async function handleToggleStudy(card) {
    const body = {
      deck_id: card.deck.id,
      question: card.question,
      answer: card.answer,
      hint: card.hint,
      in_study_pile: !card.in_study_pile,
      study_amount: !card.in_study_pile ? 3 : 0
    };
    try {
      await toggleStudy(card.id, body, props.token);
      await props.getCards(props.filter);
    } catch (error) {
      console.log("Error occured at handleToggleStudy", error);
    }
  }

  const handleClick = (e) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };
  return (
    <div className="search-card">
      <div className="search-card-content">
        <IconButton
          className="more"
          sx={{
            padding: 0,
            opacity: 0.8,
            "&:hover": {
              opacity: 1,
              backgroundColor: "transparent",
            },
          }}
          onClick={handleClick}
        >
          {open ? <CloseRounded /> : <MoreVertRounded />}
        </IconButton>

        <Popover
          className="popover-menu"
          square={false}
          slotProps={{
            paper: {
              sx: {
                boxShadow: "var(--box-shadow)",
                marginTop: 1,
              },
            },
          }}
          hidden={!open}
          open={open}
          anchorEl={anchorEl} // This links it to the button
          onClose={handleClose}
          // onMouseLeave={() => setTimeout(handleClose, 500)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <ul className="menu">
            <li>
              <div
                className="menu-link"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  props.setIndex(props.index);
                  props.showEditModal("active");
                  handleClose();
                }}
              >
                Edit
              </div>
            </li>
            <li className="no-border">
              <div
                className="menu-link"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleToggleStudy(props.card);
                  handleClose();
                }}
              >
                {props.card.in_study_pile ? "Mastered Card" : "Needs Studying"}
              </div>
            </li>
          </ul>
        </Popover>
        <SubContent label="Deck" content={props.card.deck.name} />
        <SubContent label="Question" content={props.card.question} />
        <SubContent label="Answer" content={props.card.answer} />
      </div>

      {props.card.in_study_pile ? (
        <div className="study-row">
          <LocalLibraryRounded color="inherit" />
          <p className="mb-0">Needs Studying</p>
        </div>
      ) : (
        <div className="mastered-row">
          <WorkspacePremiumRounded color="inherit" />
          <p className="mb-0">Mastered Card</p>
        </div>
      )}
    </div>
  );
};

export default Cards;
